<api-loader></api-loader>
<div *ngIf="banner" class="banner">
    <img src="assets/ic_banner_clock.svg" style="height: 20px; margin-left: 20px; margin-right: 10px;">
    <h4 [innerHTML]="'Your account is still under verification. You will be notified once it is approved' | translate" style="margin: 0; color: white;"></h4>
    <button (click)="hideBanner()" class="banner-btn">{{'Ok' | translate}}</button>
</div>
<app-translation-new *ngIf="showTranslationToggle" (isEnglish)="langChange($event)"></app-translation-new>
<div [style.margin-top]="banner ? '-50px' : ''" [class.arabic-lang]="!isEnglish" [class.english-lang]="isEnglish">
    <router-outlet></router-outlet>
</div>